<template>
  <div class="display_two_code_box">
    <div class="display_two_code">
      <img
        class="bkg"
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/member/member_wx.png"
        alt
      />
      <img
        class="close"
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/member/member_wx_code_close.png"
        alt
        @click="closeCodeModal"
      />
      <div class="content">
        <div class="title">添加老师微信</div>
        <div class="info">立即加导师微信，专属指导，学习快人一步！</div>
        <div class="code">
          <img :src="codeUrl" alt />
        </div>
        <div class="tip">{{ $root.miniprogram ? '长按二维码，添加会员群' : '长按保存二维码，前往微信扫一扫' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
// import Foot from '@/components/foot/privacy.vue';
import { reqTypeList } from '@/api/home';

export default {
  props: {
    closeCodeModal: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      codeUrl: '',
    };
  },

  components: {
    //   Foot
  },

  computed: {},

  mounted() {
    reqTypeList('MEMBER_ASSOCIATION').then(res => {
      console.log(res, 'code');
      const { value } = res.data?.[0] || {};
      this.codeUrl = value;
    });
  },

  methods: {},
};
</script>

<style scoped lang="scss">
.display_two_code_box {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 102;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);

  .display_two_code {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 757px;
    background: #fff;
    border-radius: 36px 36px 0 0;

    .bkg {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 332px;
      height: 264px;
    }

    .close {
      position: absolute;
      top: 36px;
      right: 36px;
      z-index: 3;
      width: 29px;
      height: 29px;
    }

    .content {
      position: absolute;
      z-index: 2;
      width: 100%;
      height: 100%;

      .title {
        width: 100%;
        height: 60px;
        margin-top: 43px;
        color: #333;
        font-weight: 500;
        font-size: 43px;
        font-family: PingFangSC, PingFang SC, sans-serif;
        line-height: 60px;
        text-align: center;
      }

      .info {
        height: 40px;
        margin-top: 40px;
        color: #333;
        font-weight: 500;
        font-size: 29px;
        font-family: PingFangSC, PingFang SC, sans-serif;
        line-height: 40px;
        text-align: center;
      }

      .code {
        width: 326px;
        height: 326px;
        margin: 72px auto 0;

        img {
          width: 326px;
          height: 326px;
        }
      }

      .tip {
        width: 100%;
        height: 36px;
        margin-top: 49px;
        color: #999;
        font-weight: 400;
        font-size: 25px;
        font-family: PingFangSC, PingFang SC, sans-serif;
        line-height: 36px;
        text-align: center;
      }
    }
  }
}
</style>
